import "regenerator-runtime/runtime"
import './iprom_activator'